import PropTypes from 'prop-types'

const wizardStepPropTypes = Object.freeze({
    activeStep: PropTypes.number.isRequired,
    model: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    setStep: PropTypes.func.isRequired,
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            icon: PropTypes.element,
            page: PropTypes.element.isRequired,
            subtitle: PropTypes.string,
            title: PropTypes.string
        })
    ).isRequired,
    updateModel: PropTypes.func
})

export { wizardStepPropTypes }
